var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"home"},[_c('home-box-1'),_c('home-box-2'),_c('home-box-3'),_c('home-box-4'),_c('home-box-5'),_c('home-box-6'),_c('home-box-8')],1)}
var staticRenderFns = []

export { render, staticRenderFns }